import React from 'react';
import AjudaManager from '../components/AjudaManager/AjudaManager.jsx';

export default function Ajuda() {
  return <AjudaManager />;
}
